import * as S from '../scss/theme';

import React, { useState, useEffect, useRef, useMemo } from 'react';
import JoditEditor from 'jodit-react';
import './BoardWrite.scss';
import Button from '@mui/material/Button';

import { useNavigate } from 'react-router-dom';
import axios from "axios";
import Cookies from 'js-cookie'; 
import fnc from '../mymod/commFunction';
import { useSelector, useDispatch } from 'react-redux';
import { setSelectedList, setInitialPage } from "../reduxToolkit/reduxSlice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { setIsRefreshBoard } from '../reduxToolkit/reduxBoard';
// import Upload from 'rc-upload';//이건 사용 안함
// import { Upload, message } from 'antd';// 이 안에 rc-upload 포함 됨


const BoardWrite = ({ placeholder, setIsModal_boardWrite }) => {
    

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const titleInputRef = useRef(null); 
    const [title, setTitle] = useState('');
    const [category, setCategory] = useState('');
    const [kind, setKind] = useState('');
    const editor = useRef(null);
    const [content, setContent] = useState('');
    const [startDate, setStartDate] = useState(new Date());

    const [isUpload, setIsUpload] = useState(false);
    const [boardCode, setBoardCode] = useState(null);
    const [fileListCnt, setFileListCnt] = useState(null);
    const [fileList, setFileList] = useState([]);


    const boardTitle = useSelector(state => state.reduxStoreBoard.boardTitle);
    const boardKind = useSelector(state => state.reduxStoreBoard.boardKind);
    const isRefreshBoard = useSelector(state => state.reduxStoreBoard.isRefreshBoard);

    const folder = 'board';
    

    const config = useMemo(
        () => ({
          readonly: false, // Jodit의 모든 옵션은 https://xdsoft.net/jodit/docs/ 에서 확인할 수 있습니다.
          placeholder: placeholder || '',
          // uploader: {
          //     insertImageAsBase64URI: true,
          //     imagesExtensions: ["jpg", "png", "jpeg", "gif"],
          //     filesVariableName: "file", // 서버에서 기대하는 파일 데이터의 키 이름
          //     url: 'http://localhost:3000/uploads', // 서버의 이미지 업로드 (이거 죽임)
          // },
          //대용량 파일이 mssql에 업로드돼서(3MB) 죽임
          dragAndDrop: false, // 드래그 앤 드롭을 활성화합니다. (작동 안 하는듯)
          askBeforePasteHTML: false,
          askBeforePasteFromWord: false,
          cleanHTML: {
            fillEmptyParagraph: false//<p><br><p> 제거용
            },
          colorPickerDefaultTab: "text", // 기본 탭을 텍스트로 설정
            style: {
              textAlign: 'left', // 기본 텍스트 왼쪽 정렬
          },
         
      }), [placeholder]);


      useEffect(() => {
        window.scroll(0, 0);
      }, []);

    function onPrev() {
      setIsModal_boardWrite(false);
      dispatch(setIsRefreshBoard(!isRefreshBoard));
    }


    function fncInserBoard() {   
      if (!title || !category || !content) {
        alert(!title ? '제목을 입력하세요!' : !category ? '카테고리를 선택하세요!' : '내용을 입력하세요!');
        return;
      }
      const boardCode = fnc.fncSirialNum();
        
      setBoardCode(boardCode);//파일업로드용
        fnc.sendAxios('/insert_board', { title, category, content, kind: boardKind, date:startDate, code:boardCode }, (response) => {       

          if (response) {
            dispatch(setInitialPage(0));
          if (fileList.length > 0) {
            setIsUpload(true);//파일저장 (상태변화로 처리함)
          }else {
            alert('완료되었습니다!!');
            onPrev();
          }
          
          } else {
            console.log("속성이 obj 내에 없습니다.");
          }
        });
      }
    
    //=========================================================================
    return (
    <div className='BoardWrite'>
    <div className='frame_boardWrite'>

        <div className='box_jodit'>

              <div className='box_title'>
                  <h2 className='title'>{boardTitle.text} 글쓰기</h2>
              </div>

              <div className='formGroup'>      
                    <input
                      type="text"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      placeholder="제목을 입력하세요"
                      className='titleInput' 
                      ref={titleInputRef} />

                    <div className='category_date'>
                      {/* <select
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        className='categorySelect'  >
                        <option value="">카테고리 선택</option>
                        <option value="뉴스">뉴스</option>
                        <option value="블로그">블로그</option>
                        <option value="기사">기사</option>
                      </select> */}

                      <input
                        type="text"
                        value={category}
                        onChange={(e) => setCategory(e.target.value)}
                        placeholder="카테고리를 입력하세요"
                        className='categorySelect'  />

                      <DatePicker 
                          selected={startDate} 
                          onChange={(date) => setStartDate(date)} 
                          dateFormat="yyyy-MM-dd" // 날짜 형식 지정
                      />

                    </div>

              </div>

              <JoditEditor
                      ref={editor}
                      value={content}
                      config={config}
                      tabIndex={1} // 텍스트 영역의 tabIndex
                      onBlur={newContent => setContent(newContent)} // 성능상의 이유로 컨텐츠를 업데이트하기 위해서는 이 옵션만 사용하는 것이 좋습니다.        
                      onChange={newContent => {}} 
              />

              <div className='box_btnMenu'>
                  <Button className='btn h-btn-blue'  onClick={onPrev}>목록보기</Button>
                  <Button className='btn h-btn-red' color="error" onClick={fncInserBoard}>저장하기</Button>
    
              </div>

        </div>

       
      
    </div>
    </div>
    );
};

export default BoardWrite;
